import React from 'react';
import PropTypes from 'prop-types';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';
import { WaterfallFilterType } from '@bingads-webui/filter-commons';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { siteMapPropType } from '@bingads-webui-react/with-site-map';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { getFilteredCampaignType, filterMapItemByCampaignType } from './processor-helpers';

const cachedFilter = memoize(filterMapItemByCampaignType);

export function processGlobalFilter(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const campaignType
      = getFilteredCampaignType(props[WaterfallFilterType.CampaignType]);
    const processedSiteMap = cachedFilter(siteMap, campaignType, props.permissions);

    return (<Component
      {...props}
      siteMap={processedSiteMap}
    />);
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    permissions: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.objectOf(PropTypes.bool),
      PropTypes.number,
    ])).isRequired,
  };

  return withPermissions(withGlobalFilter(Wrapper));
}
